import { Col, Row } from 'antd'
import React from 'react'
import { Helmet } from 'react-helmet'
import ProfileInfo from './ProfileInfo'

const UserProfile = ({ keycloak }) => {
    return (
        <>
            <Helmet>
                <title>My Profile - Vroom</title>
            </Helmet>
            <Row>
                <Col span={24}>
                    <section className="sec1">
                        <ProfileInfo keycloak={keycloak} />
                    </section>
                </Col>
            </Row>

        </>
    )
}

export default UserProfile
